import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { property as r } from "./property.js";

function o(o, t) {
  var e = t ? _objectSpread(_objectSpread({}, t), {}, {
    source: o
  }) : o;
  return r({
    aliasOf: e
  });
}

export { o as aliasOf };